import { render, staticRenderFns } from "./BetTypeSelector.vue?vue&type=template&id=750dd6ba&scoped=true"
import script from "./BetTypeSelector.vue?vue&type=script&lang=ts"
export * from "./BetTypeSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750dd6ba",
  null
  
)

export default component.exports